import Logo from './logo.js';
import LogoShort from './logo-short.js';
import LogoMobile from './logo-mobile.js';
import LogoSingleColor from './logo-single-color.js';
// Commenting as last decision by design team is to use the green logo.
// import LogoLanding from './logo-landing.js';
import styled from './styled-theme-overrides.js';
import '../styles.js';
import AppLogo from './app-logo.js';

const LOGO_MOBILE_WIDTH = 120; // svg logo width for mobile header

export default {
	styled,
	Logo,
	LogoShort,
	LogoMobile,
	// LogoLanding,
	LOGO_MOBILE_WIDTH,
	AppLogo,
	LogoSingleColor
};
